var Handlebars = require("../../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda;

  return "    <div\r\n        id=\""
    + this.escapeExpression(alias1((depth0 != null ? depth0.videoElementId : depth0), depth0))
    + "\"\r\n        style=\"background-color:"
    + ((stack1 = alias1(((stack1 = (depth0 != null ? depth0.announcement : depth0)) != null ? stack1.background_color : stack1), depth0)) != null ? stack1 : "")
    + ";\"\r\n    ></div>\r\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = __default(require("./announcementBlock.ts")).call(depth0,(data && data.root),{"name":"announcementBlock","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true});